import React from 'react';
import ReactDOM from 'react-dom/client';
import { ReactTagManager } from 'react-gtm-ts';

import App from './App.tsx';
import './i18n.ts';
import './index.css';

declare global {
    interface Window {
        dataLayer: Record<string, any>[];
    }
}

if (window.location.hostname === 'muo.cz') {
    ReactTagManager.init({
        code: 'GTM-5H6MN8GL',
        debug: true,
        performance: false,
    });

    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push([
            'consent',
            'default',
            {
                ad_storage: 'denied',
                analytics_storage: 'denied',
                personalization_storage: 'denied',
                security_storage: 'granted',
            },
        ]);
    }
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
